module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-7-ad9380a9df0d6b54a9a84f5fef895c15.svg";